import { call, put, takeLatest } from 'redux-saga/effects';
import {
	QuickSearchActionTypes,
	SearchTryGetResultsAction,
} from '../../store/actions/search.data.actions';

import { getQuickSearchData } from '../functions/quickSearch.function';

export function* getQuickSearchDataSaga() {
	yield takeLatest(
		QuickSearchActionTypes.QUICK_SEARCH_RESULTS_GET,
		getQuickSearchResults
	);
}

export function* getQuickSearchResults(action: SearchTryGetResultsAction) {
	yield put({
		type: QuickSearchActionTypes.QUICK_SEARCH_RESULTS_LOADING,
	});
	try {
		const response = yield call(() => getQuickSearchData(action.adviserUUID));
		yield put({
			type: QuickSearchActionTypes.QUICK_SEARCH_RESULTS_SUCCESS,
			response,
		});
	} catch (Error) {
		yield put({
			type: QuickSearchActionTypes.QUICK_SEARCH_RESULTS_FAILURE,
			Error,
		});
	}
}
